import styled from 'styled-components';

const CardContainer = styled.div`
	display: flex;
	padding: 5px;
	${props => props.theme.breakpoints.up('xs')} {
		padding-bottom: 20px;
		flex-direction: column;
		.information__icon {
			margin-right: 0px;
		}
	}
	${props => props.theme.breakpoints.up('sm')} {
		flex-direction: row;
		padding: 5px;
		.information__icon {
			margin-right: 16px;
		}
	}

	.MuiSvgIcon-root {
		color: #ffffff;
	}

	.information__title {
		${props => props.theme.breakpoints.up('xs')} {
			font-size: 16px;
		}
		${props => props.theme.breakpoints.up('sm')} {
			font-size: 18px;
		}
		${props => props.theme.breakpoints.up('md')} {
			font-size: 20px;
		}
	}

	.information__description {
		font-size: 13px;
		font-weight: 300;
		line-height: 20px;
	}
`;

export default CardContainer;
